{
  "contactModal": {
    "delete": {
      "cancel": "Cancelar",
      "confirm": "Eliminar",
      "error": {
        "contactWithInformationRequests": "contactWithInformationRequests",
        "default": "default",
        "title": "title"
      },
      "message": "¿Estás seguro de que quieres eliminar este contacto?",
      "success": "success",
      "title": "Eliminar contacto"
    }
  },
  "contacts": {
    "buttons": {
      "add": "Agregar un contacto"
    },
    "table": {
      "headers": {
        "actions": "Acciones",
        "email": "Correo electrónico",
        "id": "ID",
        "name": "Nombre"
      }
    }
  },
  "productionSiteModal": {
    "actions": {
      "cancel": "Cancelar",
      "delete": "delete",
      "save": "Guardar"
    },
    "createTitle": "Nuevo sitio de producción",
    "delete": {
      "cancel": "Cancelar",
      "confirm": "Eliminar",
      "message": "¿Estás seguro de que quieres eliminar este sitio de producción?",
      "title": "Eliminar sitio de producción"
    },
    "editTitle": "Editar un sitio de producción",
    "errors": {
      "cityRequired": "La ciudad es requerida",
      "coordinatesMaxDecimals": "La latitud y la longitud pueden tener como maximo 6 decimales",
      "countryMustBeValid": "País debe ser válido (ex. FR, DE)",
      "internalCodeTooLong": "El código interno debe tener menos de 32 caracteres",
      "nameRequired": "Nombre es requerido",
      "postalCodeTooShort": "El código postal debe tener al menos 3 caracteres",
      "streetRequired": "La calle es requerida",
      "streetTooShort": "La calle debe tener al menos 3 caracteres"
    },
    "labels": {
      "city": "Ciudad",
      "country": "País",
      "internalCode": "Código interno",
      "latitude": "Latitud",
      "longitude": "Longitud",
      "name": "Nombre del sitio de producción",
      "performedActivities": "Actividades realizadas",
      "postalCode": "Código postal",
      "registrationId": "IDs de registro del sitio",
      "street": "Calle"
    },
    "placeholders": {
      "city": "Ciudad",
      "country": "Seleccione el país del sitio",
      "internalCode": "ej. BD-DAK-001 o su referencia interna",
      "latitude": "Latitud",
      "longitude": "Longitud",
      "name": "ej. Unidad Corte y Confección Dhaka A",
      "performedActivities": "ej. Corte, costura, acabado, teñido",
      "postalCode": "ej. 75008",
      "registrationId": "ej. CIF, CIN, GSTIN, USC",
      "street": "ej. 12 rue des Fleurs"
    },
    "registrationIdDescriptions": {
      "DUNS": "DUNS: 9 dígitos.",
      "EORI": "EORI: código país + 14 dígitos.",
      "GLN": "GLN: 13 dígitos.",
      "OTHER": "Otro: máx. 32 caracteres.",
      "RCS": "RCS: RCS + espacio + nombre empresa + espacio + [A,B] + espacio + 9 dígitos.",
      "VAT": "VAT: código país (ej. FR) + 2 dígitos + 9 dígitos SIREN."
    },
    "registrationIdErrors": {
      "DUNS": "El ID de registro DUNS debe ser un número de 9 dígitos.",
      "EORI": "El ID de registro EORI debe tener el formato: código país (ej. FR) + 14 dígitos.",
      "GLN": "El ID de registro GLN debe ser un número de 13 dígitos.",
      "OTHER": "El ID de registro otro debe tener menos de 32 caracteres.",
      "RCS": "El ID de registro RCS debe tener el formato: RCS + espacio + nombre empresa + espacio + [A,B] + espacio + 9 dígitos.",
      "VAT": "El ID de registro VAT debe tener el formato: código país (ej. FR) + clave 2 dígitos + número SIREN 9 dígitos."
    },
    "tabs": {
      "generalInfo": "Información general",
      "location": "Ubicación"
    },
    "tooltips": {
      "address": "Tu dirección de envío",
      "city": "Ciudad del sitio de producción",
      "country": "País del sitio de producción",
      "internalCode": "Código interno del sitio de producción",
      "latitude": "Latitud del sitio de producción",
      "longitude": "Longitud del sitio de producción",
      "name": "Nombre del sitio de producción",
      "performedActivities": "Actividades realizadas en el sitio de producción",
      "postalCode": "Código postal del sitio de producción",
      "registrationId": "IDs de registro del sitio de producción",
      "street": "Calle del sitio de producción"
    }
  },
  "productionSites": {
    "buttons": {
      "add": "Agregar un sitio de producción"
    },
    "create": {
      "error": "Error al crear el sitio de producción",
      "success": {
        "message": "El sitio de producción ha sido creado correctamente",
        "title": "Sitio de producción creado"
      }
    },
    "delete": {
      "error": "Error al eliminar el sitio de producción",
      "success": {
        "message": "El sitio de producción ha sido eliminado correctamente",
        "title": "Sitio de producción eliminado"
      }
    },
    "filters": {
      "country": "País",
      "internalCode": "Código interno del sitio de producción",
      "isConfidential": "Confidencial",
      "isConfidentialFalse": "No",
      "isConfidentialTrue": "Sí",
      "name": "Nombre del sitio de producción",
      "nothingFoundMessage": "nothingFoundMessage",
      "performedActivities": "Actividades realizadas",
      "searchPlaceholder": "Buscar filtros",
      "title": "Filtros"
    },
    "search": {
      "placeholder": "Buscar por nombre o dirección"
    },
    "sorts": {
      "address": "Dirección",
      "country": "País",
      "email": "Correo electrónico",
      "internalCode": "Código interno",
      "name": "Nombre"
    },
    "table": {
      "headers": {
        "address": "Dirección",
        "certificates": "Certificados",
        "deleted": "Eliminado",
        "id": "ID",
        "internalCode": "Código interno",
        "name": "Nombre",
        "performedActivities": "Actividades realizadas",
        "registrationId": "IDs de registro del sitio"
      }
    },
    "title": "Sitios de Producción",
    "update": {
      "error": "Error al actualizar el sitio de producción",
      "success": {
        "message": "El sitio de producción ha sido actualizado correctamente",
        "title": "Sitio de producción actualizado"
      }
    }
  },
  "request": {
    "errors": {
      "generic": "Error"
    }
  }
}
